// theme colors
const Background = '#263238'
const FooterColor = 'indigo darken-3'
const MainColor = 'blue-grey'
const PageTitleColor = 'blue--text text--lighten-3'
const PageTitleIconColor = 'amber'

// export const AppImage = {
//   Home:  'https://cattlytics.blob.core.windows.net/assets/background-image-2.jpg'
// }

export const AppColor = {
  
  // for each view
  PageTitleIcon: PageTitleIconColor,
  PageTitle: PageTitleColor,
  ContentToolbar: 'indigo',
  ContentToolbarLight: 'indigo lighten-1',

  // toolbars / dialogs
  Light: MainColor,
  Medium: MainColor + ' darken-1',
  Dark: MainColor + ' darken-2',

  // dialog OK button
  ButtonOK: 'blue darken-1',

  // chip
  ChipBeefbooster: 'brown',
  ChipHerdtrax: 'teal darken-1',

  // icon
  IconHelp: 'yellow lighten-4',
  IconInfo: 'cyan',

  PanelBackgroundLight: MainColor + ' lighten-5',
  PanelBackground: MainColor + ' lighten-3',
  Chip: MainColor + ' lighten-5',
  ChipDisabled: MainColor + ' lighten-3',

  RoleBeefbooster: 'teal',
  RoleHerdtrax:'light-blue',
  RoleAdmin:'deep-purple',

  // progress bars
  Progress: 'indigo',

  // checkbox selection
  Selected: 'green',

  // error handling
  Warning: 'yellow darken-2',
  Error: 'red darken-4',

  // app footer
  Footer: FooterColor,

  // app background
  Background: Background
}

export const AnimalSourceId = {
  Herdtrax: 1,
  Beefbooster: 2
}

export const QueryTypeId = {
  Custom: 1,
  Template: 2,
  FromTemplate: 3
}

export const InputTypeId = {
  Dropdown: 1,
  RangeSlider: 2,
  MultiSelect: 3,
  Percentile: 4
}

export const CriterionTypeId = {
  Filter: 1,
  Trait: 2,
  OptionalFilter: 3
}

export const AnimalTypeId = {
    Calf: 0,
    Dam: 1,
    Sire: 2,
    Steer: 3
}

export const FilterName = {
  Breed: 'breed',
  BirthYear: 'yob',
  Herd: 'herd',
  Gender: 'gender',
  AnimalType: 'type',
  HerdGroup: 'herdGroup',
  ManagementGroup: 'mgmtGroup',
  BreedGroup: 'breedGroup',
  StatusGroup: 'statusGroup'
}

export const MediaPath = {
  Photos: 'photos',
  Videos: 'videos'
}